import React, { Component } from "react";

import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";

const styles = {
  clear: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 8,
  },

  left: {
    minWidth: 0,
  },

  right: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
  },
};

class TitleBar extends Component {
  render() {
    return (
      <Grid item xs className={this.props.classes.clear}>
        <div className={this.props.classes.left}>{this.props.children}</div>
        <div className={this.props.classes.right}>{this.props.buttons}</div>
      </Grid>
    );
  }
}

export default withStyles(styles)(TitleBar);
